/**
 * The approve ticks a survey opens with on the approval page.
 *
 * A fresh upload has never been approved, so its ticks come from sensor QA. A
 * survey an admin returned to the queue from its drillhole has been, and
 * ProjectsController.ApproveSurvey wrote a boolean `Approved` onto every one of
 * its shots at the time. Those are the operator's own decisions - including the
 * shots they rejected - and re-running QA over them would silently undo that.
 * On FastTrak, where QA passes everything, it would tick every shot.
 *
 * The Android app never writes `Approved`, so its presence on any shot means the
 * survey has been through approval before. Presence, not truthiness: a survey
 * whose shots were all rejected is still a previous decision.
 *
 * @param {object[]} shots        SavedShots
 * @param {(shot: object) => boolean} qaPasses  the sensor QA verdict
 * @returns {boolean[]} one tick per shot
 */
export function initialApproval(shots, qaPasses) {
    const list = shots || [];
    const decided = list.some(shot => typeof shot?.Approved === 'boolean');
    return decided
        ? list.map(shot => shot?.Approved === true)
        : list.map(shot => qaPasses(shot));
}
